enum AttentionMessageTypes {
    ATTENTION = 'type-attention',
    DEFAULT = 'type-default',
    INFO = 'type-info',
    SUCCESS = 'type-success',
    WARNING = 'type-warning',
    ERROR = 'type-error',
    PENDING = 'type-pending',
}

/*
type DEFAULT reflects default color (from design), not the default value in usage 
AttentionMessage has no default value set
When used by InfoMessage, INFO is set as default value
*/

export default AttentionMessageTypes;
